module.exports = __webpack_public_path__ + "static/media/stepperUp.d52530dc.svg";